import { Ubicacion } from "../Ubicacion"

const Tajo = () => {
  return (
    <>
      <Ubicacion nivel={1} descripcion="Tajos" />
    </>
  )
}

export { Tajo }